// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'
import ArticleCard from '/react4xp/components/ArticleCard'
import RecipeCard from '/react4xp/components/RecipeCard'
import ProductCard from '/react4xp/components/ProductCard'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// prop types
interface ListContentArticlesProps {
    
    // section props
    section?: {
        noSeparator?: boolean
        marginTop?: 'small' | 'medium' | 'big' | 'none'
        marginBottom?: 'small' | 'medium' | 'big' | 'none'
    }

    title?: string

    content: 'articles' | 'recipes' | 'products'

    // articles props
    articles?: Array<{
        href?: string
        external?: boolean
        src?: string
        srcMedium?: string
        alt?: string
        date?: string
        title?: string
        desc?: string
    }>

    // recipes props
    recipes?: Array<{
        href?: string
        external?: boolean
        src?: string
        srcMedium?: string
        alt?: string
        title?: string
        time?: string
        rating?: string
        desc?: string
    }>

    // products props
    products?: Array<{
        href?: string
        external?: boolean
        src?: string
        srcMedium?: string
        alt?: string
        title?: string
        comments?: string
        rating?: string
    }>

    bottomLink?: {
        href: string
        external?: boolean
        text?: string
    }

    className?: string
}

export default function ListContent({
    section,
    title,
    content,
    articles,
    recipes,
    products,
    bottomLink,
    className
}: ListContentArticlesProps) {

    return (
        <Section
            marginTop={section?.marginTop}
            marginBottom={section?.marginBottom}
            className={clsx('list-content', className)}
        >
            <div className='container'>

                {isNonWhitespaceString(title) && (
                    <h2 className='h1-hero-big list-content__title'>
                        {title}
                    </h2>
                )}

                {content === 'articles' && 
                    articles && articles.length > 0 && (
                        <div className='row'>
                            {articles.map((item, i) => (
                                <div className='col-md-10 offset-md-1 col-lg-4 offset-lg-0' key={i}>
                                    <ArticleCard
                                        href={item.href}
                                        external={item.external}
                                        src={item.src} // 550px x 450px
                                        srcMedium={item.srcMedium} // 450px x 350px
                                        alt={item.alt}
                                        width={400}
                                        sizes='( max-width: 992px ) 100vw, 400px'
                                        date={item.date}
                                        title={item.title}
                                        desc={item.desc}
                                    />
                                </div>
                            ))}
                        </div>  
                    )
                }

                {content === 'recipes' &&
                    recipes && recipes.length > 0 && (
                        <div className='row'>
                            {recipes.map((item, i) => (
                                <div className='col-md-10 offset-md-1 col-lg-4 offset-lg-0' key={i}>
                                    <RecipeCard
                                        href={item.href}
                                        external={item.external}
                                        src={item.src} // 500px x 500px
                                        srcMedium={item.srcMedium} // 400px x 400px
                                        alt={item.alt}
                                        width={400}
                                        sizes='( max-width: 992px ) 100vw, 400px'
                                        title={item.title}
                                        time={item.time}
                                        rating={item.rating}
                                        desc={item.desc}
                                    />
                                </div>
                            ))}
                        </div>  
                    )
                }

                {content === 'products' &&
                    products && products.length > 0 && (
                        <div className='row'>
                            {products.map((item, i) => (
                                <div className='col-md-10 offset-md-1 col-lg-4 offset-lg-0' key={i}>
                                    <ProductCard
                                        href={item.href}
                                        external={item.external}
                                        src={item.src} // 450px x 350px
                                        srcMedium={item.srcMedium} // 300px x 250px
                                        alt={item.alt}
                                        width={400}
                                        sizes='( max-width: 992px ) 100vw, 400px'
                                        title={item.title}
                                        comments={item.comments}
                                        rating={item.rating}
                                    />
                                </div>
                            ))}
                        </div>  
                    )
                }

                {isNonWhitespaceString(bottomLink.href) && (
                    <div className='list-content__bottom-link'>
                        {isNonWhitespaceString(bottomLink.text) ? (
                            <Button
                                href={bottomLink.href}
                                target={!!bottomLink.external}
                                noUnderline
                            >
                                {bottomLink.text}
                            </Button>
                        ) : (
                            isNonWhitespaceString(bottomLink.href) && (
                                <a
                                    href={bottomLink.href}
                                    target={bottomLink.external ? '_blank' : undefined}
                                    className='list-content__bottom-link__arrow'
                                >
                                    <AnimatedArrow />
                                </a>
                            )
                        )}
                    </div>
                )}

            </div>
        </Section>
        
    )
}